import React, { useState, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { Card, Button, Modal } from 'react-bootstrap';
import { Heading5, Form, TitleIcon, Validator, Icon } from '../widgets';
import { FormValidator } from '../../helpers/form-validator';
import { getDeviceList, getLatestSensorList } from '../../actions/hardware';
import { CardContainer } from '../widgets/CardContainer';
import { assignNetwork } from '../../actions/networkType';
import { getNetworkList } from '../../actions/networkType';
import { getUserFarmList } from '../../actions/farm';

const getRules = () => {
    const isSelect = (value) => { return (value === null) || (value === ""); }
    return ([
        {
            field: 'farm',
            method: 'isEmpty',
            validWhen: false,
            message: 'Farm is required.'
        },
        {
            field: 'swapDeviceId',
            method: isSelect,
            validWhen: false,
            message: 'Device is required.'
        }
    ]);

}

const NetworkSwap = ({ showSwap, onHide, selectedNetwork, selectedDeviceHistory, setSelectedDeviceHistory }) => {
    const dispatch = useDispatch();
    const { device_uuid, networkTypeId, networkId } = selectedNetwork;
    const validator = new FormValidator(getRules());
    const farmList = useSelector(state => state.farm.userFarmList);
    const deviceList = useSelector((state) => state.hardware.deviceList.payload);
    const [state, setState] = useState({
        validation: validator.valid(),
        farm: "",
        swapDeviceId: "",
    });
    const [isSaving, setIsSaving] = useState(false);
    const farmListOptions = farmList.map(item => ({
        value: item.farm_uuid,
        label: item.farm_name
    }));
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        dispatch(getUserFarmList());
    }, [])

    useEffect(() => {
        if (state.farm) {
            dispatch(getDeviceList(state.farm, (list) => {
                const egList = [];
                list.forEach(item => {
                    if (item.current_hardware_info && item.current_hardware_info.equipment_group_uuid)
                        egList.push({ equipment_group_uuid: item.current_hardware_info.equipment_group_uuid });
                })
                dispatch(getLatestSensorList(egList));
            }));
        }
    }, [state.farm])

    useEffect(() => {
        if (selectedDeviceHistory.length > 0) {
            const getMappedFarm = selectedDeviceHistory.filter((each) => each.alive);
            if (getMappedFarm.length > 0) setState({ ...state, farm: getMappedFarm[0].farm_uuid })
        }
    }, [farmList])

    useEffect(() => {
        if (device_uuid) {
            if (deviceList.length > 0) {
                const getMappedDevice = deviceList.filter((device) => device.deviceId === device_uuid);
                if (getMappedDevice.length > 0) setState({ ...state, swapDeviceId: getMappedDevice[0].deviceId })
            }
        }
    }, [deviceList])

    const deviceByFarmId = useMemo(() => {
        if (state.farm) {
            if (deviceList.length > 0) {
                const removeSelectedDeviceId = deviceList.map((each) => ({ label: each.deviceName, value: each.deviceId }));
                return removeSelectedDeviceId;
            }
        }
        return []
    }, [deviceList])

    const handleSelect = (options, id) => {
        if (options) {
            setState(prevState => {
                if (id === 'farm') {
                    return { ...prevState, [id]: options.value, swapDeviceId: "" };
                } else {
                    return { ...prevState, [id]: options.value };
                }
            });
        }


        else setState({ ...state, [id]: null });
    }

    const isAssign = useMemo(() => {
        let checkAssignApplicable = true;
        if (state.farm) {
            const getMappedFarm = selectedDeviceHistory.filter((each) => each.alive);
            if (getMappedFarm.length > 0 && state.farm !== getMappedFarm[0].farm_uuid) {
                return checkAssignApplicable = false;
            }
        }
        if (state.swapDeviceId) {
            if (state.swapDeviceId !== device_uuid) {
                return checkAssignApplicable = false;
            }
        }
        return checkAssignApplicable;
    }, [state])

    const clearInputValues = () => {
        onHide();
        setSelectedDeviceHistory([]);
        setState({ ...state, farm: "", swapDeviceId: "" })
    }

    const handleSubmit = () => {
        const s = state;
        const validation = validator.validate(s);
        setState({ ...state, validation });
        setSubmitted(true);
        if (validation.isValid) {
            const params = {
                farm_uuid: state.farm,
                device_uuid: state.swapDeviceId,
                network_uuid: networkId,
                network_type_id: networkTypeId
            }
            const cb = (isSuccess) => {
                setIsSaving(false);
                if (isSuccess) {
                    dispatch(getNetworkList());
                    setSelectedDeviceHistory([]);
                    onHide();
                }
            }
            setIsSaving(true);
            dispatch(assignNetwork(params, cb));

        }
    }

    const s = state;
    const v = useMemo(() => {
        return submitted ? validator.validate(state) : state.validation;
    }, [state])
    // const v = submitted ? validator.validate(state) : state.validation;

    return (
        <Modal show={showSwap} onHide={onHide} backdrop="static" className="equipment-modal-form">
            <CardContainer className="form-container">
                <Card className="card-form border-0 pb-2">
                    <Card.Header>
                        <Card.Title>
                            <Heading5>
                                <TitleIcon className="fa fa-wrench" />Assign Device
                            </Heading5>
                            <i className="fa fa-times close-btn" aria-hidden="true" title="close"
                                onClick={clearInputValues} />
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <Validator validation={v.farm}>
                            <Form.Label htmlFor="farm">Farm<Validator.Mand /></Form.Label>
                            <Form.Select
                                id="farm"
                                placeholder="Select Farm"
                                name="farm"
                                className="farm-select mb-4"
                                onChange={(e) => handleSelect(e, "farm")}
                                value={s.farm ? s.farm : ""}
                                options={farmListOptions}
                                sortType="asc" />
                            <Validator.Text />
                        </Validator>

                        <Validator validation={v.swapDeviceId}>
                            <Form.Label>Device<Validator.Mand /></Form.Label>
                            <Form.Select
                                id="swapDeviceId"
                                placeholder="Select Device"
                                name="swapDeviceId"
                                className="farm-select"
                                onChange={(e) => handleSelect(e, "swapDeviceId")}
                                value={s.swapDeviceId ? s.swapDeviceId : ""}
                                options={deviceByFarmId}
                                sortType="asc" />
                            <Validator.Text />
                        </Validator>
                    </Card.Body>
                </Card>
            </CardContainer>
            <Modal.Footer className='border-0'>
                <Button size="sm" variant="danger" onClick={clearInputValues}>
                    <Icon className="fa fa-ban" /> Cancel
                </Button>
                <Button size="sm" variant="primary" disabled={isAssign} onClick={() => handleSubmit()}>
                    <Icon className="fa fa-floppy-o" /> {isSaving ? " Assigning..." : " Assign"}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default NetworkSwap;